module.exports = __webpack_public_path__ + "img/menu_group.64f19401.svg";